<template>
  <div class="space-y-3">
    <div class="grid grid-cols-1 md:flex md:justify-between items-center gap-4">
      <!-- <h2 class="text-xl font-semibold text-gray-700 dark:text-gray-200">Daftar Order</h2> -->
      <div class="grid grid-cols-2 gap-4">
        <Button v-if="false" label="Bill" outlined severity="info" @click="$emit('print', 'bill-print')" />
      </div>
    </div>
    <div v-for="item in sortedOrderItems" :key="item.id" :class="[
      'relative transform transition-all duration-200 hover:shadow-lg mr-2',
      item.payment_status == 2
        ? 'bg-gray-200 dark:bg-dark-800'
        : 'bg-cream/50 dark:bg-dark-700',
    ]" class="rounded-xl px-2 py-1 border border-gray-200 dark:border-dark-700">
      <!-- Product Info -->
      <div class="flex flex-col">
        <!-- Header with Status -->
        <div class="flex flex-col items-start gap-2">
          <!-- Status Badges -->
          <div class="flex flex-wrap justify-between gap-2 w-full">
            <div v-if="item.status === 'pending'"
              class="text-xs px-2 py-1 rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100 text-center whitespace-nowrap">
              {{
                item.createdAt
                  ? "Order " + formatTime(item.createdAt, "time")
                  : "Sudah dipesan"
              }}
            </div>
            <div v-if="item.status === 'canceled'"
              class="text-xs px-2 py-1 rounded-full bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100 text-center whitespace-nowrap">
              Cancel {{ item.createdAt ? formatTime(item.createdAt, "time") : "" }}
            </div>
            <div v-else-if="item.status === 'delivered'"
              class="text-xs px-2 py-1 rounded-full bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100 text-center whitespace-nowrap">
              Sudah diantar
            </div>
            <div v-if="item.status === 'unsaved'"
              class="text-xs px-2 py-1 rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100 text-center whitespace-nowrap">
              Belum dipesan
            </div>
          </div>

          <!-- Product Name -->
          <h4 class="font-semibold text-gray-900 dark:text-gray-100 text-lg">
            {{ item.name }}
            <!-- <span v-if="item.order_type === 'take_away'"
              class="text-xs px-2 py-1 rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100 text-center whitespace-nowrap">
              Take Away
            </span> -->
          </h4>
        </div>

        <div class="flex justify-between">
          <!-- Quantity Controls and Total -->
          <div v-if="item.payment_status == 1" class="flex flex-row items-center gap-3 pt-1">
            <div class="flex items-center bg-gray-200 dark:bg-dark-800 rounded-lg p-1">
              <button v-if="item.isEdit" @click="
                item.status === 'canceled'
                  ? $emit('reduce-qty-canceled', item)
                  : $emit('reduce-qty', item)
                " :id="'reduce-qty-' + item.id" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                <MinusCircleIcon class="h-5 w-5" />
              </button>
              <input v-model="item.quantity" type="text"
                class="w-12 text-center bg-transparent font-bold text-gray-900 dark:text-gray-100"
                :class="{ 'cursor-not-allowed': !item.isEdit }" :disabled="!item.isEdit"
                @input="updateSubtotalPerItem(item)" oninput="this.value = this.value.replace(/\D/g, '')" />
              <button v-if="item.isEdit" @click="
                item.status === 'canceled'
                  ? $emit('add-qty-canceled', item)
                  : $emit('add-qty', item)
                " :id="'add-qty-' + item.id" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                <PlusCircleIcon class="h-5 w-5" />
              </button>
            </div>
          </div>

          <!-- Price Info -->
          <div>
            <div class="flex flex-row sm:flex-row justify-end items-center gap-2 w-full">
              <p v-if="item.discount_price > 0"
                class="font-medium text-gray-400 dark:text-gray-400 text-right line-through text-xs">
                {{ formatRupiah(item.price) }}
              </p>
              <p class="font-medium text-gray-600 dark:text-gray-100 text-right text-sm">
                {{
                  formatRupiah(
                    item.discount_price > 0
                      ? parseFloat(item.price) - parseFloat(item.discount_price)
                      : item.price
                  )
                }}
              </p>
            </div>

            <div class="flex flex-row sm:flex-row justify-end items-center gap-2 w-full">
              Total : 
              <p v-if="item.discount_price > 0"
                class="font-medium text-gray-400 dark:text-gray-400 text-right line-through text-lg">
                {{ formatRupiah(item.totalBeforeDiscount) }}
              </p>
              <p class="font-medium text-gray-600 dark:text-gray-100 text-right text-lg">
                {{ item.status === "canceled" ? "-" : ""
              }}{{ formatRupiah(item.totalAfterDiscount) }}
              </p>
            </div>
          </div>
        </div>

        <!-- <div v-if="item.isEdit && item.status !== 'canceled'" class="flex flex-wrap justify-end gap-4 mt-2">
          <div class="flex items-center gap-2">
            <RadioButton v-model="item.order_type" inputId="order_type1" name="order_type" value="dine_in" />
            <label for="order_type1" class="dark:text-white">Dine In</label>
          </div>
          <div class="flex items-center gap-2">
            <RadioButton v-model="item.order_type" inputId="order_type2" name="order_type" value="take_away" />
            <label for="order_type2" class="dark:text-white">Take Away</label>
          </div>
        </div> -->
        <div v-if="item.has_product_mix" class="mt-2 text-xs text-success dark:text-warning">
          <a v-if="item.isEdit" href="#" @click="$emit('edit-item-mix', item)">{{ item?.selected_product_mix?.map(mix => `${mix.name} (${mix.quantity})`).join(', ') }}</a>
          <template v-else>
            {{ item?.product_mix?.map(mix => `${mix.name} (${mix.quantity})`).join(', ') }}
          </template>
        </div>

        <!-- Note Section -->
        <div class="mt-2">
          <!-- Note Input when editing -->
          <div v-if="item.isEdit" class="w-full">
            <input v-model="item.note" type="text" :placeholder="'Tambah catatan untuk ' + item.name"
              class="w-full px-3 py-2 bg-gray-50 dark:bg-dark-900 border border-gray-200 dark:border-dark-600 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all dark:text-white"
              @change="$emit('update-note', item)" />
          </div>

          <!-- Note Display when not editing -->
          <div v-else-if="item.note" class="text-sm text-gray-600 dark:text-gray-400">
            <p class="text-gray-700 dark:text-gray-300">
              <span class="font-medium">Catatan:</span> {{ item.note }}
            </p>
          </div>
        </div>
      </div>
      <!-- Delete Button -->
      <button v-if="item.isEdit && item.payment_status == 1" @click="$emit('remove-item', item)"
        :id="'remove-item-' + item.id"
        class="absolute -top-4 -right-4 p-1.5 text-danger hover:text-hover-danger hover:bg-red-50 dark:hover:bg-red-900/50 rounded-lg transition-colors">
        <TrashIcon class="h-5 w-5" />
      </button>
      <button v-if="!item.isEdit && item.status != 'canceled'" label="Cancel" severity="danger"
        @click="$emit('cancel-order', item)"
        class="absolute -top-4 -right-4 p-1.5 text-danger hover:text-hover-danger hover:bg-red-50 dark:hover:bg-red-900/50 rounded-lg transition-colors">
        <TrashIcon class="h-5 w-5" />
      </button>
    </div>
  </div>
</template>

<script>
import {
  MinusCircleIcon,
  PlusCircleIcon,
  TrashIcon,
} from "@heroicons/vue/24/solid";
import { formatRupiah } from "@/helpers/formatRupiah";
import { formatTime } from "@/helpers/formatTime";
import { Button } from "primevue";
import { mapGetters } from "vuex";

export default {
  name: "ListOrdered",
  components: {
    MinusCircleIcon, PlusCircleIcon, TrashIcon, Button,
  },
  emits: [
    "add-qty",
    "add-qty-canceled",
    "reduce-qty",
    "update-subtotal",
    "update-note",
    "remove-item",
    "edit-note",
    "save-note",
    "cancel-order",
    "select-item-mix",
    "delete-item-mix",
  ],
  props: {
    order_items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters("kitchen_divisions", ["allKitchenDivisions"]),
    sortedOrderItems() {
      return [...this.order_items].sort((a, b) => b.id - a.id);
    },
  },
  async created() {
    await Promise.all([
      this.$store.dispatch("kitchen_divisions/fetchKitchenDivisions", {
        limit: 1000,
      }),
    ]);
    console.log(this.order_items);
  },
  data() {
    return {};
  },
  methods: {
    formatTime,
    formatRupiah,
    isSelectedItemMix(item) {
      console.log(item);
      // return this.order_items?.selected_product_mix.some(mix => mix.id === item.id);
    },
    confirmPrint(type, item) {
      this.$confirm.require({
        group: 'headless',
        header: `Apakah anda yakin ingin mencetak ${type === 'kitchen' ? 'kitchen' : 'checker'}?`,
        message: 'Silahkan konfirmasi sebelum diproses.',
        accept: () => {
          if (type === 'kitchen') {
            this.$emit('printkitchen', item);
          } else {
            this.$emit('printchecker', { items: [item], isTransaction: false });
          }
          this.$toast.add({
            severity: 'success',
            summary: 'Sukses',
            detail: `Berhasil mencetak ${type === 'kitchen' ? 'kitchen' : 'checker'}`,
            life: 3000
          });
        },
        reject: () => {
          this.$toast.add({
            severity: 'error',
            summary: 'Dibatalkan',
            detail: 'Kamu telah membatalkan pencetakan',
            life: 3000
          });
        }
      });
    },
    updateSubtotalPerItem(item) {
      this.$emit("update-subtotal", item);
    },
  },
};
</script>
